'use strict';

var bornModules = require('../../helpers/born.modules').default,
    ajax = require('../../ajax'),
    image = require('./image'),
    progress = require('../../progress'),
    productStoreInventory = require('../../storeinventory/product'),
    // tooltip = require('../../tooltip'),
    util = require('../../util'),
    bisn = require('./backinstock');


/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 **/
var updateContent = function (href, $target) {
    var $mainClass = $target.closest('#pdpMain');
    var $pdpForm = $mainClass.find('.pdpForm');
    var isRestricted = $mainClass.data('isRestricted');
    var selectedSizeGrid = $target.closest('.size-conversion-container').find("li.selected").text()!=''?$target.closest('.size-conversion-container').find("li.selected").text():$target.closest('.size-conversion-container').find("option:selected").text();
    var qty = $pdpForm.find('input[name="Quantity"]').val();
    var selectedSize = $pdpForm.find('.swatches__item .selected');
    var params = {
        format: 'ajax',
        selectedSizeGrid : selectedSizeGrid,
        Quantity : selectedSize =!null && selectedSize.length > 0 ? qty : 1
    };
    progress.show($mainClass);
    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: $mainClass.find('#product-content'),
        callback: function () {
            if (SitePreferences.STORE_PICKUP) {
                productStoreInventory.init();
            }
            bornModules.selectTags.init();
            bornModules.qtyControl.init();
            bornModules.modalToggle.init();
            image.replaceImages($mainClass);
            // tooltip.init();

            bornModules.carousel.init();

            bisn.init();
            var obj = $('.apple-pay-submt-btn');
        	if(obj.length > 0) {
        		var isSafari = (navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
                navigator.userAgent &&
                navigator.userAgent.indexOf('CriOS') == -1 &&
                navigator.userAgent.indexOf('FxiOS') == -1);
        		if(isSafari !== true) {
        			obj.remove();
        		}
        	}
        	bornModules.showMoreSwatches.init();
        	var quickviewElement = $('.quickview__dialog');
        	if (quickviewElement.length > 0){
        		$('.quickview__dialog  #productPrice > div.product-price').html($('.quickview__dialog  #hiddenPrice > div.product-price').html());
        		var addToCartBtn=$('.pdp.quickview__dialog .add-to-cart');
                if(addToCartBtn.length > 0) {
                    addToCartBtn.attr('disabled', false);
                }
        	}else {
        		$('#productPrice > div.product-price').html($('#hiddenPrice > div.product-price').html());
        	}
        }
    });

};

// avoid jerk/jump while switching between color swatches
function setMinProductHeight() {
    let ele = $('#pdp-img-row');

    const setMinHeight = () => {
        if(ele.hasClass('has-variant')) {
            setTimeout(() => {
                ele.css('min-height', ele.height());
            }, 1200);
        }
    }

    const removeMinHeight = () => {
        ele.css('min-height', '');
    }

    if (window.innerWidth < 768) {
        setMinHeight();
    }

    $(window).on('resize', () => {
        removeMinHeight();
        if (window.innerWidth < 768) {
            setMinHeight();
        }
    });
}

module.exports = function () {
    var $mainElement = $('body');

    $mainElement.on('click','.click_disabled', (e) => {
        e.stopImmediatePropagation();
        e.preventDefault(); });

    // click on swatch - should replace product content with new variant
    $mainElement.on('click', '.product-detail .swatchanchor', function (e) {
        e.preventDefault();
        var $target = $(this);
          updateContent(this.href, $target);
            if($(this).closest('.sizeContainer').data('vattr')==='size'){
                localStorage.setItem("sizetype", "sizecode");
            }
    });

    // change drop down variation attribute - should replace product content with new variant
    $mainElement.on('change', '.product-detail .variation-select', function () {
        var $target = $(this);
        if ($target.val().length === 0) { return; }
        updateContent($target.val(), $target);
    });

    $mainElement.on('change', '.product-detail .sizeConversion-select', function () {
        var $target = $(this);
        if ($target.val().length === 0) { return; }
        var url = $(this).find(':selected').attr('data-url');
        updateContent(url, $target);
        localStorage.setItem("sizetype", "unitsize");
    });
    bornModules.showMoreSwatches.init();

    setMinProductHeight();
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/product/variant.js